import PubSub from "pubsub-js";
import { events } from "./Events";

export default class DataFetcher {
  constructor({ dataUrl }) {
    this.dataUrl = dataUrl;
  }

  init() {
    if (!this.dataUrl) return;
    this.fetchData();
  }

  fetchData() {
    fetch(this.dataUrl)
      .then(response => {
        if (!response.ok) throw new Error('Error trying to fetch data.');
        return response.json();
      })
      .then(data => {
        PubSub.publish(events.DATA_FETCHED, data);
      })
      .catch(error => {
        console.error('Fetch Error:', error);
      });
  }
}